import { render, staticRenderFns } from "./Setup_Info.vue?vue&type=template&id=6d5ebf80&scoped=true&"
import script from "./Setup_Info.vue?vue&type=script&lang=js&"
export * from "./Setup_Info.vue?vue&type=script&lang=js&"
import style0 from "./Setup_Info.vue?vue&type=style&index=0&id=6d5ebf80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5ebf80",
  null
  
)

export default component.exports